module.exports = __webpack_public_path__ + "img/FEMEA_13-24.e2b74068.jpeg";